// This import loads the firebase namespace along with all its type information.
import Profile from './profile-model'

export async function load_profiles(): Promise<Profile[]> {
  throw 'Not implemented'
}

export async function delete_profile(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_profile(): Promise<Profile> {
  throw 'Not implemented'
}
